import Swiper from 'swiper';

class PostsRow {
  constructor(el) {
    this.el = el;
    this.initSlider();
  }
  initSlider() {
    new Swiper(this.el.querySelector('.swiper'), {
      speed: 400,
      slidesPerView: 1,
      loop: false,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
        },
        680: {
          slidesPerView: 3,
        },
      },
    });
  }
}

export default PostsRow;
